<template>
  <div class="no-resource-wrap">
    <slot name="header"></slot>
    <slot name="body"></slot>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: 'NoResource',
};
</script>

<style lang="scss">
.no-resource-wrap {
  @apply border border-solid border-standard-border
    rounded-lg bg-important-bg flex flex-col justify-center
    items-center w-fit ml-auto mr-auto p-8 gap-4 overflow-hidden mt-[128px]
    max-w-[544px] box-border relative text-text-default;

  .no-resource-header-wrap {
    @apply flex flex-row gap-y-2 items-center text-xl font-medium whitespace-pre-wrap max-w-full text-center;

    span {
      @apply truncate whitespace-nowrap max-w-full;
    }
  }

  .no-resource-body-wrap {
    @apply flex flex-wrap flex-row items-center gap-y-1 text-sm whitespace-pre-wrap text-center max-w-full justify-center;

    &.wrap-around-icon {
      display: unset;

      em {
        margin: none;
        margin-top: 2px;
        float: left;
      }

      span {
        display: flow;
      }
    }

    span {
      @apply text-center text-sm font-normal whitespace-pre-wrap;
    }

    .button-wrap {
      @apply w-fit px-2 py-0 my-0.5 h-6 rounded-[4px] mx-2;

      .button-icon.custom {
        @apply m-0 mr-1;
      }

      .button-label {
        @apply whitespace-nowrap font-normal;
      }
    }
  }

  .no-resource-footer-wrap {
    @apply flex flex-wrap flex-row justify-center items-center text-sm max-w-full text-inactive-text;

    em {
      @apply bg-inactive-icon;
    }
  }

  em {
    @apply flex-shrink-0 inline-flex bg-icon-default h-4 w-4 mx-1;
  }

  .no-resource-row {
    @apply flex flex-wrap flex-row items-center justify-center;
  }
}

.mobile {
  .no-resource-wrap {
    @apply max-w-[90%];

    .no-resource-header-wrap {
      span {
        overflow: unset;
        white-space: unset;
      }
    }
  }
}
</style>
